import { EquipmentType } from '../../../enums/equipment-type';
import { TFunction } from 'i18next';
import { Option } from '../../../components/form/elements/select';

/**
 * The hardcoded options and labels for equipment types.
 * These correspond to the tabs in the form, not the classifiers.
 * @param t
 */
export function getEquipmentTypeValues(t: TFunction): Option[] {
  return [
    {
      label: t('pages.equipment.self_propelled_machinery.title'),
      value: EquipmentType.selfPropelledMachinery,
    },
    {
      label: t('pages.equipment.machines_and_aggregates.title'),
      value: EquipmentType.machinesAndAggregates,
    },
  ];
}

/**
 * The hardcoded equipment measurements under MALA-66.
 * These are hardcoded, instead of being classifiers.
 */
export enum EquipmentMeasurement {
  m = 'm',
  gab = 'gab',
}

/**
 * Depending on equipment type, this returns the available measurement options.
 */
export function getEquipmentMeasurementOptionsForType(
  equipmentType: EquipmentType
): Option[] {
  // we allow meters for all types
  const allowedOptions = [
    {
      label: EquipmentMeasurement.m,
      value: EquipmentMeasurement.m,
    },
  ];
  // we allow pieces for machines and aggregates
  if (equipmentType === EquipmentType.machinesAndAggregates) {
    allowedOptions.push({
      label: EquipmentMeasurement.gab,
      value: EquipmentMeasurement.gab,
    });
  }
  return allowedOptions;
}
